"use client";

import Enquiry from "../utils/enquiry-one/enquiry";

const EnquiryOne = () => {
    return (
        <section className="enquiry-one-section py-10 flex flex-col gap-6 sm:gap-14">
            <div className="container px-4 mx-auto gap-6 sm:gap-14">
                <Enquiry />
            </div>
        </section>
    );
};

export default EnquiryOne;
